import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;

  .animated-gif-thumb {
    max-width: 80px;
  }

  .funded-deposited {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .portal-button {
    margin: 20px 0px;
    width: 250px;
  }

  p {
    text-align: center;
    padding-top: 20px;
  }

  h3 {
    color: ${palette("color", 15)};
    padding-top: 10px;
    text-align: center;
  }
`;
